import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { AtendentesComponent } from './atendentes/atendentes.component';
import { AtendentesRoutingModule } from './atendentes-routing.module';
import { ListAtendentesComponent } from './components/list-atendentes.component';
import { EditAtendenteComponent } from './edit-atendentes/edit-atendente.component';
import { EditDevicesAtendenteComponent } from './edit-devices-atendentes/edit-devices-atendente.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';


@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    AtendentesRoutingModule,
    MatIconModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  declarations: [
    AtendentesComponent,
    EditAtendenteComponent,
    ListAtendentesComponent,
    EditDevicesAtendenteComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class AtendentesModule { }